import {
  collection,
  getFirestore,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

export async function getHomeDocuments() {
  const db = getFirestore();
  const q = query(collection(db, "home"), orderBy("priority", "desc"));

  const querySnapshot = await getDocs(q);
  const data = querySnapshot.docs.map((doc) => doc.data());

  return data;
}
